import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useVerifyPasswordlessToken } from "../api/auth";
import LoadingPage from "../components/common/LoadingPage";
import { Button, Center, Container, Text, Box } from "@mantine/core";

function Passwordless() {
  const { token } = useParams();
  const navigate = useNavigate();

  const { data, isPending, isError, isSuccess, error } =
    useVerifyPasswordlessToken(token);

  useEffect(() => {
    if (isSuccess && data && data.token) {
      // Save the JWT token and redirect the user to the callback (or home) page.
      localStorage.setItem("token", data.token);
      navigate("/callback"); // adjust your redirect route as needed.
    }
  }, [isSuccess, data, navigate]);

  if (isPending) {
    return <LoadingPage />;
  }

  if (isError || !data || !data.token) {
    return (
      <Container size={420} py="xl">
        <Box
          bg="var(--mantine-color-red-0)"
          p="md"
          style={{
            borderRadius: "var(--mantine-radius-md)",
            boxShadow: "var(--mantine-shadow-sm)",
          }}
        >
          <Center>
            <Text c="red" size="lg" fw={700} ta="center">
              Oops! Something went wrong.
            </Text>
          </Center>
          <Center mt="sm">
            <Text c="dimmed" size="sm" ta="center">
              Error verifying your token:
              <br />
              {error?.message || "An unknown error occurred. Please try again."}
            </Text>
          </Center>
        </Box>
        <Center mt="xl">
          <Button
            onClick={() => navigate("/login")}
            h="40"
            radius="md"
            size="md"
            color="#2b3846"
          >
            Back to Login
          </Button>
        </Center>
      </Container>
    );
  }

  // In theory, this point shouldn't be reached because of the redirect.
  return null;
}

export default Passwordless;
